
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { RunnitBulkActionsMixin } from '@/mixins/RunnitBulkActionsMixin';
import RunnitSelectedVideo from '@/views/Runnits/RunnitSelectedVideo.vue';
// import RunnitSettingHelperBtn from '@/views/Runnits/RunnitSettings/RunnitSettingHelperBtn.vue';
import VideoUpload from "@/views/Runnits/RunnitSettings/ImageInput/VideoUpload.vue";
import {
	IMAGE_UPLOAD_MODE,
	UploadFile,
} from '@run-diffusion/shared';
import { RunnitsImageSelectMixin } from "@/mixins/RunnitsImageSelectMixin";
import { TeamUserMixin } from '@/mixins';

export default Vue.extend({
	name: 'VideoInputSelectedVideoContainer',
	props: {
		value: { type: Object, default: null },
		libraryText: { type: String, default: 'Library' },
		// hasInpainting: { type: Boolean, default: false },
		hasStrength: { type: Boolean, default: false },
		fieldUuid: { type: String, default: null },
		videoDuration: { type: Number, default: null },
	},
	mixins: [
		RunnitBulkActionsMixin,
		RunnitsImageSelectMixin,
		TeamUserMixin,
	],
	computed: {
		...mapState([
			'user',
			'runnitState',
			'dragAndDrop',
		]),
		...mapGetters([
			// 'getInpaintingEditorState',
		]),
		isVideoSelected () {
			return !!(
				this.videoValue &&
				(
					this.videoValue.nodeRunResult ||
					this.videoValue.upload
				)
			);
		},
		videoValue () {
			let val = this.value
			if (/* this.hasInpainting || */this.hasStrength) {
				val = this._get(this.value, 'video') || null;
			}
			return val;
		},
		// inpaintingValue () {
		// 	if (this.hasInpainting) {
		// 		return this._get(this.value, 'inpainting') || { mask: null };
		// 	}
		// 	return null;
		// },
		strengthValue () {
			if (this.hasStrength) {
				return this._get(this.value, 'strength') || 0.8;
			}
			return null;
		},
		rightPercentage () {
			// Convert 0-1 range to percentage
			return Math.round((this.strengthValue || 0) * 100);
		},
		leftPercentage () {
			// Always 100 - right percentage to ensure they add up to 100%
			return 100 - this.rightPercentage;
		},
		leftIcon () {
			return 'mdi-video-outline';
		},
		rightIcon () {
			return 'mdi-text';
		},
		leftIconSize () {
			const minSize = 18;
			const maxSize = 24;
			const strengthPercent = this.strengthValue || 0;
			const size = maxSize - (strengthPercent * (maxSize - minSize));
			return `${size}px`;
		},
		rightIconSize () {
			const minSize = 18;
			const maxSize = 24;
			const strengthPercent = this.strengthValue || 0;
			const size = minSize + (strengthPercent * (maxSize - minSize));
			return `${size}px`;
		},
	},
	data () {
		return {
			IMAGE_UPLOAD_MODE,
			showMaskOverBackground: false,
		};
	},
	methods: {
		...mapActions([
			'updateRunnitState',
			// 'updateInpaintingEditorState',
			// 'removeInpaintingEditorState',
		]),
		onClear () {
			this.$emit('on-clear');
		},
		onLibrary () {
			this.$emit('on-library');
		},
		async fetchVideoUrl () {
			if (this.videoValue.nodeRunResult) {
				const { imageUrl } = await this.fetchSrc(this.videoValue.nodeRunResult, 'nodeRunResult');
				return imageUrl;
			}
			if (this.videoValue.upload) {
				const { imageUrl } = await this.fetchSrc(this.videoValue.upload, 'upload');
				return imageUrl;
			}
		},
		// async handleInpaintingClick () {
		// 	const currentState = this.getInpaintingEditorState(this.fieldUuid);
		// 	if (currentState.saving) return;

		// 	const videoUrl = await this.fetchVideoUrl();

		// 	// Close other menus globally
		// 	this.updateRunnitState({
		// 		promptGeneratorOpen: false,
		// 		imageSelectOpen: false,
		// 	});

		// 	// Update field-specific state
		// 	if (currentState.open) {
		// 		this.removeInpaintingEditorState(this.fieldUuid);
		// 	} else {
		// 		this.updateInpaintingEditorState({
		// 			fieldUuid: this.fieldUuid,
		// 			editorState: {
		// 				open: true,
		// 				backgroundImageUrl: videoUrl,
		// 			},
		// 		});
		// 	}
		// },
		onStrengthInput (strengthVal: number) {
			this.$emit('on-strength-change', strengthVal);
		},
		handleVideoUpload (upload: UploadFile) {
			this.$emit('on-upload', upload);
		},
		toggleVideoSelectionMode () {
			this.$emit('on-toggle-video-selection-mode');
		},
	},
	components: {
		VideoUpload,
		RunnitSelectedVideo,
		// RunnitSettingHelperBtn,
	},
});
